import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { WebMcpClient } from './webmcp.types';
import {
  WebMcpConfirmDialogComponent,
  WebMcpConfirmDialogData,
} from './webmcp-confirm-dialog/webmcp-confirm-dialog.component';

/**
 * Asks the signed-in human to approve an action an AI agent requested through WebMCP.
 * Every write made by an agent goes through here so nothing is created without a person seeing it.
 */
@Injectable({
  providedIn: 'root',
})
export class WebMcpConfirmService {
  private dialog = inject(MatDialog);

  confirm(data: WebMcpConfirmDialogData, client?: WebMcpClient): Promise<boolean> {
    const ask = () =>
      firstValueFrom(
        this.dialog
          .open(WebMcpConfirmDialogComponent, { data, disableClose: true, autoFocus: false })
          .afterClosed(),
      ).then((result) => result === true);

    // Let the browser pause the agent while the dialog is open, when it supports that.
    if (typeof client?.requestUserInteraction === 'function') {
      return client.requestUserInteraction(ask);
    }
    return ask();
  }
}
